<template>
    <div class="wrapper">
      <div class="title">中华人民共和国进境物品完税价格表</div>
      <div class="content">
        <div class="scroll">
          <img :src="require('../../../assets/tax/page'+i+'.png')" alt="" v-for="i in 25" :key="i">
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "tax"
    }
</script>

<style scoped>
  .title{
    border-bottom: 1px solid rgb(112,112,112);
    margin-bottom: 30px;
  }
  .content{
    width: 820px;
    height: 1000px;
    margin: 0 auto;
    overflow-y: scroll;
    margin-bottom: 40px;
    border:1px solid rgb(192,192,192);
    padding: 30px 0;

  }
  .scroll{

  }
  .content img{
    margin-bottom: 30px;
    width: 600px;
    /*width: 710px;*/
    /*height: 980px;*/
  }
</style>



// WEBPACK FOOTER //
// src/view/PageService/components/tax.vue